import classNames from 'classnames'

import SkeletonText from 'components/SkeletonBriefing/SkeletonText'

import type { ITextComponentView } from './text-component.types'
import { TextEditor } from '../text-editor'
import './text-component.styles.scss'

export const TextComponentView = ({
  textContent,
  hasFocus,
  handleTextChange,
  handleClickInDivOverlay,
  toolbarAlign,
  isViewMode,
  isLoading,
  textAreaHeight,
}: ITextComponentView) => {
  if (isLoading) {
    return <SkeletonText height={textAreaHeight} />
  }

  return (
    <div className={classNames(['TextComponent', { isViewMode }])}>
      {!hasFocus && <div className="wall" onClick={handleClickInDivOverlay} />}
      <TextEditor
        textContent={textContent}
        handleTextChange={handleTextChange}
        toolbarAlign={toolbarAlign}
        isViewMode={isViewMode}
      />
    </div>
  )
}
